import PropTypes from 'prop-types';
import React from 'react';
import { getComponentClasses } from '@99designs/utils/app';
import deprecated from '../lib/deprecated';

export default class Pill extends React.Component {
    render() {
        const variations = this.props.variations.slice();

        if (this.props.type) {
            // Add type as first variation
            deprecated(`Pill:type is deprecated, prefer variations={[\'${this.props.type}\']}`);
            variations.unshift(this.props.type);
        }

        if (variations.length === 0) {
            // This is required because we've removed the default value for type.
            // TODO: Remove this, when removing type prop.
            variations.push('info');
        }

        if (this.props.sizeVariation) {
            deprecated(`Pill:sizeVariation is deprecated, prefer variations={[\'${this.props.sizeVariation}\']}`);
            variations.push(this.props.sizeVariation);
        }

        const classes = getComponentClasses('pill', variations);

        return (
            <span className={classes} title={this.props.title}>
                {this.props.children}
            </span>
        );
    }
}

Pill.propTypes = {
    title: PropTypes.string,
    variations: PropTypes.array,
    sizeVariation: PropTypes.oneOf(['small', 'tiny']),
    type: PropTypes.oneOf(
        ['notification', 'info', 'callout', 'success']
    ),
};

Pill.defaultProps = {
    title: '',
    variations: [],
    sizeVariation: null,
};



// WEBPACK FOOTER //
// ./node_modules/@99designs/react-components/components/Pill.jsx